/* eslint-ignore */
// @ts-nocheck
import React from 'react';

import { Container } from './styles';

function CustomButton({
  buttonType,
  children,
  iconLeft: IconLeft,
  iconRight: IconRight,
  disabled,
  ...props
}) {
  return (
    <Container
      disabled={disabled}
      buttonType={buttonType}
      {...props}
      float={IconLeft ? 'left' : 'right'}
    >
      {IconLeft && !disabled && <IconLeft size={22} />}
      {children}
      {IconRight && !disabled && <IconRight size={22} />}
    </Container>
  );
}

export default CustomButton;
